import axios from "axios";

export const http = axios.create({
    timeout: 30000,
});

export const onSuccess = ({ data }) => data;
export const onSuccessWithHeaders = ({ data, headers }) => ({ data, headers });
export const onFail = ({ response }) => {
    console.warn('ResponseError:', response);
    throw response;
};
